import React from "react";

export const StepProgressBar = ({
  count,
  currentIndex,
}: {
  count: number;
  currentIndex: number;
}) => (
  <div className="flex w-full gap-1.5">
    {Array.from({ length: count }, (_, idx) => {
      let segmentBgClass = "bg-line/40"; // future steps
      if (idx < currentIndex) {
        segmentBgClass = "bg-teal"; // completed steps
      } else if (idx === currentIndex) {
        segmentBgClass = "bg-gold"; // current step
      }
      return (
        <div
          key={idx}
          className={`h-2 flex-1 rounded-full transition-colors duration-300 ${segmentBgClass}`}
        />
      );
    })}
  </div>
);
